import OnboardingSlides from 'components/OnboardingSlides';

import { StyledLayout, StyledContainer, StyledPaper } from './OnboardingScreen.styles';

interface OnboardingProps {
  onDone: () => void;
}

const Onboarding = ({ onDone }: OnboardingProps) => (
  <StyledLayout ariaLabel="App instructions" hideHeader>
    <StyledContainer>
      <StyledPaper>
        <OnboardingSlides onDone={onDone} />
      </StyledPaper>
    </StyledContainer>
  </StyledLayout>
);

export default Onboarding;
